import {NgModule} from '@angular/core';
import {OccupationalProfileBaseInfoComponent} from './occupational-profile-base-info.component';
import {CommonModule} from '@angular/common';
import {NavigationInfoComponent} from "./navigation-info.component";
import {RouterModule} from "@angular/router";

@NgModule({
    imports: [
        CommonModule, RouterModule
    ],
    providers: [
    ],
    declarations: [
        OccupationalProfileBaseInfoComponent, NavigationInfoComponent
    ],
    exports: [
        OccupationalProfileBaseInfoComponent
    ]
})

export class BaseInfoModule {

}
